import { useTranslation } from 'react-i18next';

import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import { getPointLabel } from 'approot/shared/logic/content-label';

type Props = {
  score?: number | null;
};

const SuggestedAnswerScoreView = ({ score }: Props) => {
  const { t } = useTranslation();
  const scoreValue = score === null || score === undefined ? 1 : score;
  const pointLabel = getPointLabel(t, { plural: scoreValue > 1 });

  return <BadgeSmallStyled>{`${scoreValue} ${pointLabel}`}</BadgeSmallStyled>;
};

export default SuggestedAnswerScoreView;
